import { render } from "./jyzx.vue?vue&type=template&id=65b651e0&scoped=true"
import script from "./jyzx.vue?vue&type=script&lang=js"
export * from "./jyzx.vue?vue&type=script&lang=js"

import "./jyzx.vue?vue&type=style&index=0&id=65b651e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b651e0"]])

export default __exports__